/**
 * @generated SignedSource<<e01a1f0d4925fa7a147d450ef34f2ffb>>
 * @relayHash e0b190bf64245807c65c6a39fad85827
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7af624c4b97f5163cdbcbee972e35b6547b5f51e02f920991591ce39d904fdbc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type WorkspaceThemePreferenceQuery$variables = {
  accountId: string;
  workspaceAri: string;
};
export type WorkspaceThemePreferenceQuery$data = {
  readonly settings_userPreferencesResolved: {
    readonly theme: string | null | undefined;
  } | null | undefined;
};
export type WorkspaceThemePreferenceQuery = {
  response: WorkspaceThemePreferenceQuery$data;
  variables: WorkspaceThemePreferenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_userPreferencesResolved",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WorkspaceThemePreferenceQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceThemePreferenceQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e0b190bf64245807c65c6a39fad85827",
    "id": "7af624c4b97f5163cdbcbee972e35b6547b5f51e02f920991591ce39d904fdbc",
    "metadata": {},
    "name": "WorkspaceThemePreferenceQuery",
    "operationKind": "query",
    "text": "query WorkspaceThemePreferenceQuery($workspaceAri:ID!,$accountId:ID!){settings_userPreferencesResolved(workspaceAri:$workspaceAri,accountId:$accountId){theme}}"
  }
};
})();

(node as any).hash = "be26c2ad7c5bd92bf5027028e6136697";

export default node;
